export const EXPERIMENTS = {
  ENABLE_MULTILINE_ADDRESS: 'specs.forms.MultilineAddressInTemplates',
  SHOW_DEMO_FORM: 'specs.forms.ShowDemoForm',
  ENABLE_PRESET_TAB: 'specs.forms.EnablePresetTab',
  BUTTON_TEXT_FORMATTING: 'specs.forms.SettingsButtonTextFormatting',
  WIX_SERVICES_INSTALLATION: 'specs.forms.WixServicesInstallation',
  CREATE_FORM_FROM_PRESET: 'specs.forms.CreateFormFromPreset',
  TEMPLATE_DESIGNER: 'specs.forms.TemplateDesigner',
  REMOVE_BOOKINGS_DEPENDENCY: 'specs.services.RemoveBookingsDependency',
  BIF_ON_MEETINGS_PHASE_3: 'specs.bookings.InstallMeetingsForBIF',
  BIF_INSTALL_ONLY_MEETINGS: 'specs.bookings.BIFInstallOnlyMeetings',
  BOXLESS_TEXT_STYLES: 'specs.forms.BoxlessTextStyles',
};
